export default __webpack_public_path__ + "static/media/3d-glasses-3.31956195.png";